import { useState } from "react";

export type ImagePreviewProps = { file: File };
export const ImagePreview = ({ file }: ImagePreviewProps) => {
  const [error, setError] = useState<string>();
  const [dataUrl, setDataUrl] = useState<string>();
  const reader = new FileReader();

  reader.onload = (e) => {
    if (typeof e.target?.result === "string") setDataUrl(e.target.result);
    setError("");
  };
  reader.onerror = (e) => {
    setError("Error loading image");
  };
  reader.readAsDataURL(file);
  return (
    <div>
      {dataUrl ? (
        <img src={dataUrl} alt={file.name} />
      ) : error ? (
        <p>Error loading image</p>
      ) : (
        <p>Loading image...</p>
      )}
    </div>
  );
};
